<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
body, p, span{
  font-family: proxima-nova;
}
@media only screen and (max-width: 992px) {
  .el-col-offset-6 {
    margin-left: 0!important;
  }
}

body{
  margin:0;
  background-color: #EEEEEE;
}
#app {
  font-family: proxima-nova, Helvetica, sans-serif;
  text-align: center;
}

.auth-panel{
    background-color: #FFFFFF;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    min-height: 200px;
    padding: 0 40px 40px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
.auth-header {
  background-color: #042144;
  min-height: 40px;
  border-top: 5px solid #ef559a;
  padding: 20px;
  margin-top: 20px;
}
.auth-header img {
  width: 140px;
}

button.el-button--primary {
  background-color: #d7347d;
  border-color: #d7347d;
}
button.el-button--primary:hover,
button.el-button--primary:active,
button.el-button--primary:visited,
button.el-button--primary:focus{
  background-color:#ef559a;
  border-color: #ef559a;
}

.to-login { margin-top: 20px; color:#999; text-decoration: none; display: block; font-size: 14px;}
.auth-form {
  padding: 20px 0 0;
}
.auth-form .el-form-item{
  margin-bottom: 15px;
}
.auth-form label.el-form-item__label{
  width: 100%;
  padding: 0;
  line-height: 24px;
}

.auth-form button.el-button--primary{
  width: 100%;
  margin-top: 10px;
}
 
.section-title {
  font-family: 'prohibition';
  color: #666;
}
</style>
